export default "__VITE_ASSET__CwXDj_4Y__"